<div class="igo-layer-list-item">
  <div class="layer-content">
    @if (viewerOptions().mode === 'selection') {
      <mat-checkbox
        [checked]="selected()"
        [disabled]="selectionDisabled()"
        (change)="handleSelect($event)"
      />
    }
    <ng-content />
    <span
      class="igo-layer-title"
      [matTooltip]="tooltipText"
      matTooltipShowDelay="500"
      (click)="toggleLegendOnClick()"
    >
      {{ layer().title }}
    </span>
  </div>

  <div class="list-actions">
    <div class="list-secondary-actions">
      @if (viewerOptions().mode !== 'selection') {
        <button
          class="actions-button"
          tooltip-position="below"
          matTooltipShowDelay="500"
          [matTooltip]="'igo.geo.layer.moreOptions' | translate"
          mat-icon-button
          color="primary"
          (click)="toggleLayerTool()"
        >
          <mat-icon>more_horiz</mat-icon>
        </button>
      }
    </div>

    <igo-layer-visibility-button
      [layer]="layer()"
      [tooltip]="visibilityTooltip"
      [disabled]="isDisabled"
      [inResolutionsRange]="layer().isInResolutionsRange$ | async"
      [showQueryBadge]="queryBadgeHidden() === false"
      (visibilityChange)="handleVisibilityChange($event)"
    />
  </div>
</div>

@if (showLegend()) {
  <div class="igo-layer-legend-container">
    <igo-layer-legend
      [layer]="layer()"
      [updateLegendOnResolutionChange]="
        viewerOptions().legend.updateOnResolutionChange
      "
    />
  </div>
}
